import {
    TOUR_COMPARE_SUCCESS,
    TOUR_COMPARE_ERROR,
    TOUR_COMPARE_START
} from "../Constant/TourCompareConstant";

const initialState = {
    loading: false,
    data: [],
};

export default function TourCompareReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case TOUR_COMPARE_START:
            return {
                ...state,
                loading: true,
            };
        case TOUR_COMPARE_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case TOUR_COMPARE_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}
